import React from 'react';
import './preload.css';
import Colibris from '../../assets/images/colibrisbleu.png';

const Preload = () => {
  return <img className="preload-img" src={Colibris} alt="MCR logo" />;
};

export default Preload;
